import { Box, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { isExternalHref } from "../../constants";

const ListLink = ({
  label,
  href,
  iconClass = "fas fa-file-alt",
  iconBg = "#EEEDFE",
  iconColor = "#534AB7",
  variant = "icon",
  divider = false,
  statusLabel,
}) => {
  const isStatic = Boolean(statusLabel) || !href;
  const external = !isStatic && isExternalHref(href);
  const className = [
    "edsimsV2-list-link",
    variant === "icon" ? "edsimsV2-list-link--icon" : "edsimsV2-list-link--plain",
    divider ? "edsimsV2-list-link--divider" : "",
    isStatic ? "edsimsV2-list-link--static" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const content = (
    <>
      <Box className="edsimsV2-list-link-content">
        {variant === "icon" ? (
          <Box
            className="edsimsV2-list-link-icon"
            style={{ backgroundColor: iconBg, color: iconColor }}
            aria-hidden="true"
          >
            <i className={iconClass} aria-hidden="true" />
          </Box>
        ) : null}
        <p
          className={[
            "edsimsV2-list-link-label",
            variant === "plain" ? "edsimsV2-list-link-label--plain" : "",
            isStatic ? "edsimsV2-list-link-label--muted" : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          {label}
        </p>
      </Box>
      {statusLabel ? (
        <span className="edsimsV2-list-link-status">{statusLabel}</span>
      ) : (
        <i
          className="fas fa-chevron-right edsimsV2-list-link-chevron"
          aria-hidden="true"
        />
      )}
      {!isStatic && external ? (
        <span className="edsimsV2-sr-only">(opens in a new tab)</span>
      ) : null}
    </>
  );

  if (isStatic) {
    return (
      <Box
        component="li"
        className={`edsimsV2-list-link-item ${className}`}
        tabIndex={0}
        title={statusLabel ? `${label}: ${statusLabel}` : label}
        aria-label={statusLabel ? `${label}, ${statusLabel}` : label}
      >
        {content}
      </Box>
    );
  }

  return (
    <Box component="li" className="edsimsV2-list-link-item">
      <Link
        component={external ? "a" : RouterLink}
        href={external ? href : undefined}
        to={external ? undefined : href}
        target={external ? "_blank" : undefined}
        rel={external ? "noopener noreferrer" : undefined}
        underline="none"
        color="inherit"
        className={className}
      >
        {content}
      </Link>
    </Box>
  );
};

export default ListLink;
